
import { Service } from "@/store/user/types";
import { defineComponent, defineEmits } from "vue";
import store from "@/store";

export default defineComponent({
    name: 'NavBar',
    props: ['userServices'],
    data() {
        return {
            mp3: false,
            serverWork: false,
            window: {
                width: 0,
                height: 0
            }
        }
    },
    emits: ['route'],
    created() {
        this.window = store.getters['window/windowSize']
    },
    watch: {
        userServices: function(newVal) {
            newVal.forEach((element: Service) => {
                if (element.service == '80a6d350-fc81-4116-a8e1-18e02d789980') {
                    this.mp3 = true
                    this.serverWork = element.server
                }
            });
        }
    },
    methods: {
        showMenu() {
            const element = document.querySelector(`.dropdown-head-menu-content`);
            if (element instanceof HTMLElement) {
                if (element.style.display == 'none') {
                    element.style.display = 'block';
                } else {
                    element.style.display = 'none';
                    element.style.removeProperty('display');
                }
            } else {
                console.log(`Элемент с классом "dropdown-head-menu-content" не найден.`);
            }
        },
        emitRoute(route: string) {
            const element = document.querySelector(`.dropdown-head-menu-content`);
            if (element instanceof HTMLElement) {
                element.style.display = 'none';
                //element.style.removeProperty('display');
            } else {
                console.log(`Элемент с классом "dropdown-head-menu-content" не найден.`);
            }
            this.$emit('route', route)
        },
        exit() {
            store.dispatch('user/clear')
        }
    }
})
